import DateRangePersistentService from 'nightwatch-web/services/persistence/date-range';

export default class DashboardService extends DateRangePersistentService {
  RANGE_KEY = 'nw:dashboard:date-range';
}
